exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#new-personnel[data-v-3fd6806c] {\n    padding: 5px 8px;\n    border: 1px dashed #ccc;\n}\n#new-personnel[data-v-3fd6806c]:hover {\n    cursor: pointer;\n}\n", ""]);

// exports
